<template>
  <BaseUiStyleSkinSet />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
